import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-16 bg-gray-50" data-id="element-69">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-70">
        <div className="text-center mb-12" data-id="element-71">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-72">Contact Us</h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-73">
            Have questions or ready to start investing? Get in touch with our
            team for personalized assistance.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-74">
          <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-75">
            <h3 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-76">
              Send Us a Message
            </h3>
            <form className="space-y-6" data-id="element-77">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-78">
                <div data-id="element-79">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-80">
                    Full Name
                  </label>
                  <input type="text" id="name" name="name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="Your name" required data-id="element-81" />
                </div>
                <div data-id="element-82">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-83">
                    Email Address
                  </label>
                  <input type="email" id="email" name="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="your.email@example.com" required data-id="element-84" />
                </div>
              </div>
              <div data-id="element-85">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-86">
                  Phone Number
                </label>
                <input type="tel" id="phone" name="phone" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="Your phone number" required data-id="element-87" />
              </div>
              <div data-id="element-88">
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-89">
                  Subject
                </label>
                <select id="subject" name="subject" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" required data-id="element-90">
                  <option value="" data-id="element-91">Select a subject</option>
                  <option value="account" data-id="element-92">Account Opening</option>
                  <option value="trading" data-id="element-93">Trading Queries</option>
                  <option value="investment" data-id="element-94">Investment Advisory</option>
                  <option value="technical" data-id="element-95">Technical Support</option>
                  <option value="other" data-id="element-96">Other</option>
                </select>
              </div>
              <div data-id="element-97">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-98">
                  Message
                </label>
                <textarea id="message" name="message" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" placeholder="How can we help you?" required data-id="element-99"></textarea>
              </div>
              <div className="flex items-start" data-id="element-100">
                <input id="privacy" name="privacy" type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded mt-1" required data-id="element-101" />
                <label htmlFor="privacy" className="ml-2 block text-sm text-gray-600" data-id="element-102">
                  I agree to the processing of my personal data in accordance
                  with the privacy policy.
                </label>
              </div>
              <button type="submit" className="w-full bg-blue-800 text-white px-6 py-3 rounded-md font-medium hover:bg-blue-700" data-id="element-103">
                Submit
              </button>
            </form>
          </div>
          <div data-id="element-104">
            <div className="bg-white p-8 rounded-lg shadow-sm mb-8" data-id="element-105">
              <h3 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-106">
                Contact Information
              </h3>
              <div className="space-y-6" data-id="element-107">
                <div className="flex items-start" data-id="element-108">
                  <MapPin className="h-6 w-6 text-blue-600 mr-3 flex-shrink-0" data-id="element-109" />
                  <div data-id="element-110">
                    <h4 className="font-medium text-gray-900" data-id="element-111">
                      Office Address
                    </h4>
                    <p className="text-gray-600 mt-1" data-id="element-112">
                      123 Financial District, Bandra Kurla Complex
                      <br data-id="element-113" />
                      Mumbai, Maharashtra 400051
                      <br data-id="element-114" />
                      India
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-115">
                  <Phone className="h-6 w-6 text-blue-600 mr-3 flex-shrink-0" data-id="element-116" />
                  <div data-id="element-117">
                    <h4 className="font-medium text-gray-900" data-id="element-118">Phone</h4>
                    <p className="text-gray-600 mt-1" data-id="element-119">
                      +91 22 1234 5678
                      <br data-id="element-120" />
                      +91 98765 43210 (Customer Support)
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-121">
                  <Mail className="h-6 w-6 text-blue-600 mr-3 flex-shrink-0" data-id="element-122" />
                  <div data-id="element-123">
                    <h4 className="font-medium text-gray-900" data-id="element-124">Email</h4>
                    <p className="text-gray-600 mt-1" data-id="element-125">
                      info@maxcapsecurities.com
                      <br data-id="element-126" />
                      support@maxcapsecurities.com
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-127">
                  <Clock className="h-6 w-6 text-blue-600 mr-3 flex-shrink-0" data-id="element-128" />
                  <div data-id="element-129">
                    <h4 className="font-medium text-gray-900" data-id="element-130">
                      Business Hours
                    </h4>
                    <p className="text-gray-600 mt-1" data-id="element-131">
                      Monday - Friday: 9:00 AM - 6:00 PM
                      <br data-id="element-132" />
                      Saturday: 10:00 AM - 2:00 PM
                      <br data-id="element-133" />
                      Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-blue-800 text-white p-6 rounded-lg" data-id="element-134">
              <h3 className="text-lg font-semibold mb-3" data-id="element-135">Customer Support</h3>
              <p className="mb-4" data-id="element-136">
                Our dedicated customer support team is available to assist you
                with any queries or concerns.
              </p>
              <a href="tel:+919876543210" className="inline-block bg-white text-blue-800 px-4 py-2 rounded-md font-medium hover:bg-gray-100" data-id="element-137">
                Call Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}